var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAspIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NET_Core_Logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 35.539,
    cy: 35.539,
    rx: 35.539,
    ry: 35.539,
    transform: "translate(0.921)",
    fill: "#5c2d91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M11.124,9A35.9,35.9,0,1,0,61.806,59.682Z",
    transform: "translate(0.892 0.302)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M7.447,37.346a1.4,1.4,0,0,1-1.034-.434,1.426,1.426,0,0,1-.424-1.034,1.447,1.447,0,0,1,.424-1.034A1.385,1.385,0,0,1,7.447,34.4a1.416,1.416,0,0,1,1.034.444,1.437,1.437,0,0,1,.434,1.034,1.482,1.482,0,0,1-1.468,1.468Z",
    transform: "translate(1.123 3.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M27.763,37.612H25.055L15.37,22.584a6.2,6.2,0,0,1-.6-1.178h-.083a19.349,19.349,0,0,1,.1,2.584V37.612h-2.2V18.77h2.863l9.426,14.759q.589.92.765,1.261H25.7a19.927,19.927,0,0,1-.134-2.77V18.77h2.2Z",
    transform: "translate(2.668 2.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M42.015,37.612H32V18.77h9.55v1.995h-7.3v6.263h6.8v1.984h-6.8v6.532h7.772Z",
    transform: "translate(4.934 2.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M56.425,20.765H50.947V37.612h-2.2V20.765H43.33V18.77h13.1Z",
    transform: "translate(7.306 2.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M26.331,49.674a5.1,5.1,0,0,1-2.4.506,3.866,3.866,0,0,1-2.966-1.189,4.4,4.4,0,0,1-1.116-3.1A4.61,4.61,0,0,1,21.1,42.522a4.258,4.258,0,0,1,3.183-1.282,5.1,5.1,0,0,1,2.067.362v1.034a4.134,4.134,0,0,0-2.067-.517,3.163,3.163,0,0,0-2.429,1.034,3.762,3.762,0,0,0-.93,2.667,3.586,3.586,0,0,0,.868,2.532,2.956,2.956,0,0,0,2.284.941,4.279,4.279,0,0,0,2.264-.579Z",
    transform: "translate(3.332 5)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M30.308,50.1a2.873,2.873,0,0,1-2.2-.92,3.214,3.214,0,0,1-.817-2.3,3.349,3.349,0,0,1,.858-2.439,3.1,3.1,0,0,1,2.3-.879,2.78,2.78,0,0,1,2.16.858,3.39,3.39,0,0,1,.775,2.367,3.328,3.328,0,0,1-.837,2.377,2.935,2.935,0,0,1-2.243.941Zm.072-5.654a1.891,1.891,0,0,0-1.509.651,2.677,2.677,0,0,0-.558,1.8,2.532,2.532,0,0,0,.558,1.736,1.912,1.912,0,0,0,1.509.641,1.819,1.819,0,0,0,1.478-.62,2.708,2.708,0,0,0,.517-1.778,2.749,2.749,0,0,0-.517-1.788,1.809,1.809,0,0,0-1.478-.641Z",
    transform: "translate(4.193 5.129)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M37.965,44.756a1.22,1.22,0,0,0-.755-.2,1.271,1.271,0,0,0-1.034.6,2.77,2.77,0,0,0-.424,1.633v3.163H34.72v-6.2h1.034v1.292h0a2.171,2.171,0,0,1,.651-1.034,1.478,1.478,0,0,1,.972-.362,1.623,1.623,0,0,1,.589.083Z",
    transform: "translate(4.93 5.126)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M43.9,47.114H39.525a2.315,2.315,0,0,0,.527,1.592,1.922,1.922,0,0,0,1.468.558,3.1,3.1,0,0,0,1.922-.692v.93a3.6,3.6,0,0,1-2.16.589,2.625,2.625,0,0,1-2.067-.848,3.462,3.462,0,0,1-.754-2.377,3.39,3.39,0,0,1,.817-2.357,2.636,2.636,0,0,1,2.067-.91,2.336,2.336,0,0,1,1.881.786,3.287,3.287,0,0,1,.661,2.191Zm-1.034-.837a2.067,2.067,0,0,0-.413-1.333,1.416,1.416,0,0,0-1.137-.475,1.6,1.6,0,0,0-1.189.506,2.284,2.284,0,0,0-.61,1.313Z",
    transform: "translate(5.466 5.131)",
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspIcon);
export default __webpack_public_path__ + "static/media/asp-icon.7786e5e1626409ce2182ee70c9a862f5.svg";
export { ForwardRef as ReactComponent };